import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Kyostat, Kyotens } from './../../../models/plan/kyotens';
import {
  Customersearch,
  ResultslistCustomer,
  Sort
} from './../../../models/plan/searchcustomer';
import { Stuffstat } from './../../../models/plan/staffs';
import { SearchCustomer } from './../../../models/searchCustomer';
import { PlanMainService } from './../../service/plan-main.service';
import { Subject } from 'rxjs/Subject';
import { CustomerCar } from '../../../models/plan/customerCar';
import { PaginatorsComponent } from '../../../shared/components/paginators/paginators.component';

export interface RankMasterList {
  rankCd?: string;
  rankNm?: string;
  rankstat?: boolean;
}


@Component({
  selector: 'app-quotation-search-2',
  templateUrl: './quotation-search-2.component.html',
  styleUrls: ['./quotation-search-2.component.css']
})
export class QuotationSearch2Component implements OnInit, OnDestroy {
  @Output('close') close: any = new EventEmitter<any>();
  @Input() customervalue: SearchCustomer = null;
  @Input() customersearchstatus = false;
  @Input() houjinKbn: any = 0;
  @Input() showCustomerSearch: boolean = false;
  @ViewChild("paginator") paginator: PaginatorsComponent;
  public customersearchlist: Customersearch;
  public listvalue: ResultslistCustomer[] = [];
  public selectedRow: number;

  public customerNo: string = null;

  public kojinNmKjFirst: string = null;
  public kojinNmKjLast: string = null;
  public houjinNmKj: string = null;

  public kojinNmFnFirst: string = null;
  public kojinNmFnLast: string = null;
  public houjinNmFn: string = null;

  public telNumber1: string = null;
  public telNumber2: string = null;
  public telNumber3: string = null;

  public mobileNumber1: string = null;
  public mobileNumber2: string = null;
  public mobileNumber3: string = null;

  public mailMobile: string = null;
  public mailPc: string = null;

  public phonetic: string = null;

  public rank1CdStart: string = null;
  public rank1CdEnd: string = null;

  public rank2CdStart: string = null;
  public rank2CdEnd: string = null;

  public bunrui1CdStart: string = null;
  public bunrui1CdEnd: string = null;

  public bunrui2CdStart: string = null;
  public bunrui2CdEnd: string = null;

  public showstrRank1: string = null;

  public showstrRank2: string = null;

  public showstr2Rank1: string = null;

  public showstr2Rank2: string = null;

  public showstr3Rank1: string = null;
  public showstr3Rank2: string = null;

  public showstr4Rank1: string = null;
  public showstr4Rank2: string = null;

  public datalist: RankMasterList[] = [];
  public moderank: number = null;

  // public kyotens: Kyotens[] = [];
  public selectKyotens: Kyotens;

  public kyotenCd: string = null;
  public kyotenNm: string = null;
  public kyotendisplay = false;
  public kyotens: Kyostat[] = [];

  public staffCd: any = null;
  public staffNm: any;
  public rankNm: any;
  public rankCd: any;

  public tantous: Stuffstat[] = [];
  public tantoudisplay = false;

  public dataenterkey: ResultslistCustomer = null;

  public display = false;

  public modevalue: any;

  // public shodanKbn: any = null;
  public shodanKbn: any = null;
  public shodanKbnVal: any[] = [];
  public modelIndexForClear: any;

  public ngUnsubscribe = new Subject();

  public sortTable = null;
  public nameOrPlateNo: string = null;
  public pagesize: number;
  public tempSearch: SearchCustomer;
  constructor(private _planmainService: PlanMainService) { }
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      if (this.dataenterkey != null) {
        this.onenterData(this.dataenterkey, this.selectedRow);
      }
    }
  }

  ngOnInit() {
    this.shodanKbnVal = [
      {
        kbnCd: 1,
        kbnNm: '見込顧客'
      },
      {
        kbnCd: 2,
        kbnNm: '納車顧客'
      }
    ];
    this.datalist = [];

    if (this.customervalue) {
      if (this.customervalue.nameOrPlateNo) {
        this.nameOrPlateNo = this.customervalue.nameOrPlateNo;
        this.onsearch();
      } else {
        if (this.customervalue.houjinNmKj) {
          this.houjinNmKj = this.customervalue.houjinNmKj;
        } else {
          if (this.customervalue.kojinNmKjFirst) {
            this.kojinNmKjFirst = this.customervalue.kojinNmKjFirst;
          }
          if (this.customervalue.kojinNmKjLast) {
            this.kojinNmKjLast = this.customervalue.kojinNmKjLast;
          }
        }
      }
    } else {
      this.shodanKbn = this.shodanKbnVal[0];
    }
    
  }

  // onsearch() {
  // if (this.shodanKbn === '') {
  //   this.shodanKbn = null;
  // }
  // if (this.houjinKbn === '') {
  //   this.houjinKbn = null;
  // }
  // if (this.kyotenCd === '') {
  //   this.kyotenCd = null;
  // }
  // if (this.kojinNmKjFirst === '') {
  //   this.kojinNmKjFirst = null;
  // }
  // if (this.kojinNmKjLast === '') {
  //   this.kojinNmKjLast = null;
  // }
  // if (this.houjinNmKj === '') {
  //   this.houjinNmKj = null;
  // }
  // if (this.kojinNmFnFirst === '') {
  //   this.kojinNmFnFirst = null;
  // }
  // if (this.kojinNmFnLast === '') {
  //   this.kojinNmFnLast = null;
  // }
  // if (this.houjinNmFn === '') {
  //   this.houjinNmFn = null;
  // }
  // if (this.customerNo === '') {
  //   this.customerNo = null;
  // }
  // if (this.telNumber1 === '') {
  //   this.telNumber1 = null;
  // }
  // if (this.telNumber2 === '') {
  //   this.telNumber2 = null;
  // }
  // if (this.telNumber3 === '') {
  //   this.telNumber3 = null;
  // }
  // if (this.mobileNumber1 === '') {
  //   this.mobileNumber1 = null;
  // }
  // if (this.mobileNumber2 === '') {
  //   this.mobileNumber2 = null;
  // }
  // if (this.mobileNumber3 === '') {
  //   this.mobileNumber3 = null;
  // }
  // if (this.mailMobile === '') {
  //   this.mailMobile = null;
  // }
  // if (this.mailPc === '') {
  //   this.mailPc = null;
  // }
  // if (this.rank1CdStart === '' || this.showstrRank1 === '') {
  //   this.rank1CdStart = null;
  // }
  // if (this.rank1CdEnd === '' || this.showstrRank2 === '') {
  //   this.rank1CdEnd = null;
  // }
  // if (this.rank2CdStart === '' || this.showstr2Rank1 === '') {
  //   this.rank2CdStart = null;
  // }
  // if (this.rank2CdEnd === '' || this.showstr2Rank2 === '') {
  //   this.rank2CdEnd = null;
  // }
  // if (this.bunrui1CdStart === '' || this.showstr3Rank1 === '') {
  //   this.bunrui1CdStart = null;
  // }
  // if (this.bunrui1CdEnd === '' || this.showstr3Rank2 === '') {
  //   this.bunrui1CdEnd = null;
  // }
  // if (this.bunrui2CdStart === '' || this.showstr4Rank1 === '') {
  //   this.bunrui2CdStart = null;
  // }
  // if (this.bunrui2CdEnd === '' || this.showstr4Rank2 === '') {
  //   this.bunrui2CdEnd = null;
  // }
  // if (this.customervalue === '') {
  //   this.customervalue = null;
  // }

  // if (this.staffCd === '' || this.staffNm === '') {
  //   this.staffCd = null;
  // }

  // this.searchCustomer
  onsearch(sort?) {
    this.selectedRow = null;
    this.dataenterkey = null;
    let checkSearch = false;
    if (sort == null) {
      if (this.pagesize) {
        sort = {'rowSelect': this.pagesize, page: 1};
      }
    } else {
      this.pagesize = sort.rowSelect;
      checkSearch = true;
    }

    let searchCustomer: SearchCustomer = {
      // shodanKbn: this.shodanKbn,
      kojinNmKjFirst: this.kojinNmKjFirst,
      kojinNmKjLast: this.kojinNmKjLast,
      houjinNmKj: this.houjinNmKj,
      kojinNmFnFirst: this.kojinNmFnFirst,
      kojinNmFnLast: this.kojinNmFnLast,
      houjinNmFn: this.houjinNmFn,
      customerNo: this.customerNo,
      telNumber1: this.telNumber1,
      telNumber2: this.telNumber2,
      telNumber3: this.telNumber3,
      mobileNumber1: this.mobileNumber1,
      mobileNumber2: this.mobileNumber2,
      mobileNumber3: this.mobileNumber3,
      mailMobile: this.mailMobile,
      mailPc: this.mailPc,
      kyotenCd: this.kyotenCd, // null,
      rank1CdStart: this.rank1CdStart,
      rank1CdEnd: this.rank1CdEnd,
      rank2CdStart: this.rank2CdStart,
      rank2CdEnd: this.rank2CdEnd,
      bunrui1CdStart: this.bunrui1CdStart,
      bunrui1CdEnd: this.bunrui1CdEnd,
      bunrui2CdStart: this.bunrui2CdStart,
      bunrui2CdEnd: this.bunrui2CdEnd,
      nameOrPlateNo: this.nameOrPlateNo,
      houjinKbn: this.houjinKbn, //  null,
      staffCd: this.staffCd
    };
    if (this.shodanKbn) {
      searchCustomer.shoudanKbn = this.shodanKbn.kbnCd;
    }
    if (checkSearch && this.tempSearch) {
      if (JSON.stringify(this.tempSearch) != JSON.stringify(searchCustomer)) {
        searchCustomer = this.tempSearch;
      }
    }
    // console.log(searchCustomer);
    this._planmainService
      .getSearchCustomer(searchCustomer, sort)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((response: Customersearch) => {
        this.tempSearch = searchCustomer;
        this.setResponse(response);
      });
  }

  setResponse(response: Customersearch) {
    this.listvalue = [];
    if (response && Object.keys(response).length > 0) {
      this.sortTable = { rowSelection: response.size, totalSize: response.totalSize, row: response.size };
      this.customersearchlist = response;
      this.listvalue = this.customersearchlist.results;
      this.paginator.setPage(response.page, this.sortTable);
    }
  }

  lazyLoadePage(event) {
    // console.log('​lazyLoadePage -> event', event);
    this.onsearch(event);
  }

  oncorporate(event: any) {
    console.log(this.houjinKbn);
  }

  setClickedRow(index: any, data: ResultslistCustomer) {
    if (this.selectedRow !== index) {
      this.selectedRow = index;
      this.dataenterkey = data;
    } else {
      this.selectedRow = null;
      this.dataenterkey = null;
    }
  }

  onConfirm() {
    let tmpData: any;
    if (this.dataenterkey != null) {
      if (this.showCustomerSearch) {
        tmpData = {
          kojinNmKjSei: this.dataenterkey.kojinNmKjSei,
          kojinNmKjMei: this.dataenterkey.kojinNmKjMei,
          kojinNmKnSei: this.dataenterkey.kojinNmKnSei,
          kojinNmKnMei: this.dataenterkey.kojinNmKnMei
        }
        this._planmainService.setDataQuotationCustomers(tmpData);
      } else {
        this._planmainService.setDataQuotationCustomers(this.dataenterkey);
      }
      // console.log(this.dataenterkey);
      this.close.emit();
    }
  }

  onDbclickTable(data: ResultslistCustomer) {
    let tmpData: any;
    if (data) {
      if (this.showCustomerSearch) {
        tmpData = {
          kojinNmKjSei: data.kojinNmKjSei,
          kojinNmKjMei: data.kojinNmKjMei,
          kojinNmKnSei: data.kojinNmKnSei,
          kojinNmKnMei: data.kojinNmKnMei
        }
        this._planmainService.setDataQuotationCustomers(tmpData);
      } else {
        this._planmainService.setDataQuotationCustomers(data);
      }
    }
    this.close.emit();
  }

  onenterData(data: ResultslistCustomer, index: any) {
    this._planmainService.setDataQuotationCustomers(data);
    this.close.emit();
  }

  // onKyotyens(event: any) {
  //   this.kyotenCd = this.selectKyotens.kyotenCd;
  //   this,
  //   console.log(this.kyotenCd);
  //   this.staffNm = '';
  //   // console.log(this.selectKyotens);
  //   // console.log(this.kyotens[0]);
  // }

  getKyoten() {
    // this.display = true;
    this.kyotendisplay = true;
    if (this.kyotenCd == null) {
      this.kyotens = [];
      this._planmainService.getkyotens().subscribe((res: Kyotens[]) => {
        this.kyotens.push({
          kyotenCd: '000',
          kyotenNm: '未選択',
          kyostat: false
        });
        res.forEach((val, i) => {
          this.kyotens.push({
            kyotenCd: val.kyotenCd,
            kyotenNm: val.kyotenNm,
            kyostat: false
          });
        });
      });
    }
  }

  // onKyotyens(event: any) {
  //   this.kyotenCd = this.selectKyotens.kyotenCd;
  //   // this,
  //     console.log(this.kyotenCd);
  //   this.staffNm = '';
  //   // console.log(this.selectKyotens);
  //   // console.log(this.kyotens[0]);
  // }

  kyotenSelected(kyoten: any, event: any) {
    if (kyoten.kyotenCd === '000') {
      setTimeout(() => {
        this.kyotens.forEach((val, i) => {
          if (kyoten.kyotenCd !== val.kyotenCd) {
            this.kyotens[i].kyostat = false;
          }
        });

        this.kyotenNm = '';
        this.staffNm = '';
        this.kyotenCd = null;
        this.staffCd = null;
        this.oncloseDialog(event);
      }, 500);
    } else {
      setTimeout(() => {
        this.kyotenCd = kyoten.kyotenCd;
        this.kyotenNm = kyoten.kyotenNm;
        this.staffNm = '';
        this.staffCd = null;
        this.oncloseDialog(event);
      }, 500);
    }
  }

  checkedKyotenSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    console.log(event + ' ' + i);

    if (this.kyotens[i].kyostat === event) {
      this.kyotens[i].kyostat = false;
      // this.carvalue.modelNm = null;
      this.kyotenCd = null;
    } else {
      for (let i = 0; i < this.kyotens.length; i++) {
        this.kyotens[i].kyostat = false;
      }
      this.kyotens[i].kyostat = true;
    }
  }

  onShodanKbn(event: any) {
    console.log(this.shodanKbn);
  }

  onClose() {
    this.close.emit();
  }

  openrank(val: any, mode: any) {
    this.display = true;
    this.moderank = val;
    this.modevalue = mode;
    this.datalist = [];
    this._planmainService
      .getrankMasterList(val)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((data: any[]) => {
        if (data != null && data.length != 0) {
          this.datalist = data;
          console.log(this.datalist);
        }
      });
  }

  oncloseDialog(event: any) {
    this.display = false;
    this.datalist = [];
    this.tantoudisplay = false;
    this.kyotendisplay = false;
  }

  onRowSelect(event: any) {
    console.log(event);
    setTimeout(() => {
      if (this.moderank == 1) {
        if (this.modevalue == 1) {
          this.rank1CdStart = event.rankCd;
          this.showstrRank1 = event.rankNm;
        } else if (this.modevalue == 2) {
          this.rank1CdEnd = event.rankCd;
          this.showstrRank2 = event.rankNm;
          // this.rank1CdEnd = event.data.rankCd;
          // this.showstrRank2 = event.data.rankNm;
        }
      } else if (this.moderank == 2) {
        if (this.modevalue == 1) {
          this.rank2CdStart = event.rankCd;
          this.showstr2Rank1 = event.rankNm;
          // this.rank2CdStart = event.data.rankCd;
          // this.showstr2Rank1 = event.data.rankNm;
        } else if (this.modevalue == 2) {
          this.rank2CdEnd = event.rankCd;
          this.showstr2Rank2 = event.rankNm;
          // this.rank2CdEnd = event.data.rankCd;
          // this.showstr2Rank2 = event.data.rankNm;
        }
      } else if (this.moderank == 3) {
        if (this.modevalue == 1) {
          this.bunrui1CdStart = event.rankCd;
          this.showstr3Rank1 = event.rankNm;
          // this.bunrui1CdStart = event.data.rankCd;
          // this.showstr3Rank1 = event.data.rankNm;
        } else if (this.modevalue == 2) {
          this.bunrui1CdEnd = event.rankCd;
          this.showstr3Rank2 = event.rankNm;
          // this.bunrui1CdEnd = event.data.rankCd;
          // this.showstr3Rank2 = event.data.rankNm;
        }
      } else if (this.moderank == 4) {
        if (this.modevalue == 1) {
          this.bunrui2CdStart = event.rankCd;
          this.showstr4Rank1 = event.rankNm;
          // this.bunrui2CdStart = event.data.rankCd;
          // this.showstr4Rank1 = event.data.rankNm;
        } else if (this.modevalue == 2) {
          this.bunrui2CdEnd = event.rankCd;
          this.showstr4Rank2 = event.rankNm;
          // this.bunrui2CdEnd = event.data.rankCd;
          // this.showstr4Rank2 = event.data.rankNm;
        }
      }
      this.display = false;
    }, 500);
  }

  displayTantou() {
    this.tantoudisplay = true;
    if (this.tantous.length === 0) {
      this.getTantou();
    }
  }

  getTantou() {
    // this.display = true;
    // this.tantoudisplay = true;
    this.tantous = [];
    // if (this.tantous) {
    this._planmainService.getStaffname().subscribe(res => {
      if (res) {
        this.tantous.push({
          staffCd: '000',
          staffNm: '未選択',
          staffstat: false
        });
        res.forEach((val, i) => {
          this.tantous.push({
            staffCd: val.staffCd,
            staffNm: val.staffNm,
            staffstat: false
          });
        });
      }
    });
    // }
  }

  tantouSelected(tantou: any, event: any) {
    if (tantou.staffCd === '000') {
      setTimeout(() => {
        // this.tantous.forEach((val, i) => {
        //   if (tantou.staffCd !== val.staffCd) {
        //     this.kyotens[i].kyostat = false;
        //   }
        // });
        this.staffNm = '';
        this.staffCd = null;
        this.oncloseDialog(event);
      }, 500);
    } else {
      setTimeout(() => {
        this.staffCd = tantou.staffCd;
        this.staffNm = tantou.staffNm;
        console.log(tantou);
        this.oncloseDialog(event);
      }, 500);
    }
  }

  checkedTantouSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    console.log(event + ' ' + i);

    if (this.tantous[i].staffstat === event) {
      this.tantous[i].staffstat = false;

      this.kyotenCd = null;
    } else {
      for (let i = 0; i < this.tantous.length; i++) {
        this.tantous[i].staffstat = false;
      }
      this.tantous[i].staffstat = true;
    }
  }

  focus(next) {
    (<HTMLInputElement>document.getElementById(next)).focus();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    // if (this.kyotensSubscription) {
    //   this.kyotensSubscription.unsubscribe();
    // }
    // if (this.searchCustomerSubscription) {
    //   this.searchCustomerSubscription.unsubscribe();
    // }
    // if (this.rankMasterSubscription) {
    //   this.rankMasterSubscription.unsubscribe();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/quotation-search/quotation-search-2/quotation-search-2.component.ts